import { render, staticRenderFns } from "./gamifyLoginGlobalUpdate.vue?vue&type=template&id=02a8c8ed&lang=pug"
import script from "./gamifyLoginGlobalUpdate.vue?vue&type=script&lang=js"
export * from "./gamifyLoginGlobalUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports